export default __webpack_public_path__ + "static/article-finance-best-value-used-cars-d5cb2fee09a25d4500e26dd7bb7c0f62.jpg";